import { Trans } from "translations";
import { Button } from "ui-kit/Button";

type BuyButtonProps = {
  oldAmount: string | null;
  newAmount: string;
  onPress: VoidFunction;
  loading?: boolean;
  disabled?: boolean;
};

export const BuyButton = ({
  oldAmount,
  newAmount,
  onPress,
  loading,
  disabled,
}: BuyButtonProps) => {
  return (
    <Button
      title={
        <Trans
          i18nKey="insurance.buy_text_with_discount"
          values={{
            oldAmount,
            newAmount,
          }}
          components={[<s key="old" />]}
        />
      }
      onPress={onPress}
      loading={loading}
      disabled={disabled}
    />
  );
};
